<template>
  <div ref="domRef" :class="['base-card-info', marginBottom ? 'mb-0' : '']">
    <div class="info-card-title">
      公司介绍
    </div>
    <div class="base-info-list introduce">
      <div class="left-list gap-y-[14px]">
        <div class="item">
          <div class="label">
            公司介绍
          </div>
          <div class="value">
            {{ baseInfo.companySettled?.companyProfile || '--' }}
          </div>
        </div>
        <div class="item">
          <div class="label">
            业务场景
          </div>
          <div class="value">
            {{ baseInfo.companySettled?.companyScene || '--' }}
          </div>
        </div>
        <div class="item">
          <div class="label h-[30px] leading-[30px]">
            《企业入驻表》
          </div>
          <div v-if="isNull(baseInfo.companySettled?.settledList) || baseInfo.companySettled?.settledList.length === 0" class="value">
            --
          </div>
          <div v-else class="value !block">
            <div
              v-for="(v, idx) in baseInfo.companySettled?.settledList"
              :key="idx"
              class="flex align-items-center !gap-[6px]"
            >
              <div class="flex justify-between items-center px-2 cursor-pointer text-[#344767] text-sm h-[30px]">
                <div class="flex h-full items-center">
                  <svg-icon class="file-icon mr-2 !w-4 !h-4" icon="ph:file-text" />
                  <div class="w-[200px] truncate">
                    {{ v?.fileName }}
                  </div>
                </div>
                <div class="flex h-full items-center">
                  <svg-icon class="file-icon main-primary-text mx-2 !w-4 !h-4" icon="tabler:arrow-bar-to-down" @click="downLoadFile(v)" />
                  <svg-icon
                    v-if="imageTypeStrs.includes(getFileExt(v.fileUrl)) || officeFileTypes.includes(getFileExt(v.fileUrl))"
                    class="file-icon main-primary-text"
                    icon="lucide:search"
                    @click="previewFile(v)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="label h-[30px] leading-[30px]">
            企业门头照
          </div>
          <div class="value">
            <div v-if="isNull(baseInfo.companySettled?.caseList) || baseInfo.companySettled?.caseList.length === 0" class="value">
              --
            </div>
            <template v-else>
              <span v-for="(v, idx) in baseInfo.companySettled?.caseList" :key="idx">
                <img :src="v.fileUrl" alt="">
              </span>
            </template>
          </div>
        </div>
        <div class="item">
          <div class="label h-[30px] leading-[30px]">
            办公场所照
          </div>
          <div class="value">
            <div v-if="isNull(baseInfo.companySettled?.officeList) || baseInfo.companySettled?.officeList.length === 0" class="value">
              --
            </div>
            <template v-else>
              <img v-for="(v, idx) in baseInfo.companySettled?.officeList" :key="idx" :src="v.fileUrl" alt="">
            </template>
          </div>
        </div>
        <div class="item">
          <div class="label h-[30px] leading-[30px]">
            业务场景照
          </div>
          <div class="value">
            <div v-if="isNull(baseInfo.companySettled?.sceneList) || baseInfo.companySettled?.sceneList.length === 0" class="value">
              --
            </div>
            <template v-else>
              <img v-for="(v, idx) in baseInfo.companySettled?.sceneList" :key="idx" :src="v.fileUrl" alt="">
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ICompanyMergeInfo } from '@core/main/types';
import { downloadLinkFile } from '@core/api';
import { getFileExt, officeFileTypes, imageTypeStrs, isNull } from '@core/tools';
import { openImagePreviewByUrl, SvgIcon, useElementImgPreview } from '@vue3/components';
import { inject, ref } from 'vue';
import { previewOfficeFile } from '@core/main';

defineOptions({ name: 'CompanyIntroduction' }); // 账户中心 - 公司介绍

defineProps({
  marginBottom: {
    type: Boolean,
    default: false,
  },
});

const domRef = ref<HTMLDivElement>();

useElementImgPreview(domRef);

/**
 * @function 预览文件
*/
function previewFile(file: any) {
  if (officeFileTypes.includes(getFileExt(file.fileUrl))) {
    previewOfficeFile(file.fileUrl);
  }
  if (imageTypeStrs.includes(getFileExt(file.fileUrl))) {
    openImagePreviewByUrl(file.fileUrl);
  }
}
/**
 * @function 下载文件
*/
function downLoadFile(file: any) {
  downloadLinkFile(file.fileUrl);
}

const baseInfo = inject('baseInfo') as ICompanyMergeInfo;
</script>

<style lang="scss" scoped>
:deep(.file-icon) {
  @apply w-[16px] h-[16px];
}

.item .label {
  @apply text-[var(--color-text-desc)] text-right;
}
</style>
